import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BASE_URL } from '../../models/global-constant.model';

export interface LeadBookingSlot {
  slot_start: string;
  slot_end: string;
  timezone: string;
}

/** Project branding returned with public lead-booking availability (including error responses). */
export interface LeadBookingBranding {
  _id?: string;
  office_id?: string;
  user_id?: string;
  project_id?: string;
  primary_color?: string;
  secondary_color?: string;
  text_color?: string;
  logo?: string | null;
  reserve_logo?: string | null;
}

export interface LeadBookingAvailabilityBody {
  slots: LeadBookingSlot[];
  branding?: LeadBookingBranding | null;
}

export interface LeadBookingBookResult {
  booking_id: string;
  google_event_id: string;
  task_id: string;
}

export type LeadBookingApiEnvelope<T> = {
  status: boolean;
  message?: string;
  data?: T;
};

@Injectable({
  providedIn: 'root',
})
export class LeadBookingPublicApiService {
  private readonly http: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
  }

  getAvailability(token: string, fromYmd: string, toYmd: string): Observable<LeadBookingApiEnvelope<LeadBookingAvailabilityBody>> {
    const params = new HttpParams({ fromObject: { token, from: fromYmd, to: toYmd } });
    return this.http.get<LeadBookingApiEnvelope<LeadBookingAvailabilityBody>>(`${BASE_URL}/public/lead-booking/availability`, {
      params,
    });
  }

  book(body: { token: string; slot_start: string; slot_end: string; timezone?: string }): Observable<LeadBookingApiEnvelope<LeadBookingBookResult>> {
    return this.http.post<LeadBookingApiEnvelope<LeadBookingBookResult>>(`${BASE_URL}/public/lead-booking/book`, body);
  }
}
